/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, InlineNotification, Typography, breakpoints } from '@coursera/cds-core';
import { BarChartTwoFillIcon, TargetIcon, TrophyIcon } from '@coursera/cds-icons';

import EmptyTrendingSkillsRow from 'bundles/enterprise-admin-home/components/EmptyTrendingSkillsRow';

import _t from 'i18n!nls/enterprise-admin-home';

const styles = {
  notification: () => css`
    margin: var(--cds-spacing-300) 0 var(--cds-spacing-600);
    width: 100%;
  `,
  wrapper: () => css`
    height: 100%;

    ${breakpoints.down('md')} {
      padding-bottom: var(--cds-spacing-300);
    }
  `,
};

type Props = {
  orgSlug: string;
};

const EmptySkillsCardBody = ({ orgSlug }: Props) => {
  return (
    <Grid container alignContent="space-between" css={styles.wrapper}>
      <div css={styles.notification}>
        <InlineNotification severity="information">
          {_t(
            'Trending Skills data will become available in the next 30 days as learners start engaging with the platform.'
          )}
        </InlineNotification>
      </div>
      <Grid item xs={12}>
        <Typography variant="h2" component="h3">
          {_t('Stay one step ahead with skills insights')}
        </Typography>
        <EmptyTrendingSkillsRow
          icon={TargetIcon}
          title={_t('Identify popular skill areas')}
          description={_t('Pinpoint the skills in which your learners are making progress.')}
          linkText={_t('Explore skill development')}
          link={`/o/${orgSlug}/admin/analytics/skills-development`}
          trackingName="enterprise_admin_explore_skill_development"
        />
        <EmptyTrendingSkillsRow
          icon={TrophyIcon}
          title={_t('Understand your strengths')}
          description={_t('Discover hidden skill talent within your organization.')}
          linkText={_t('Explore mastery')}
          link={`/o/${orgSlug}/admin/analytics/skills-growth`}
          trackingName="enterprise_admin_explore_mastery"
        />
        <EmptyTrendingSkillsRow
          icon={BarChartTwoFillIcon}
          title={_t('Remain competitive')}
          description={_t('Leverage industry skills benchmark data to guide your learning and development strategy.')}
          linkText={_t('Explore skills index')}
          link={`/o/${orgSlug}/admin/analytics/industry-benchmarks`}
          trackingName="enterprise_admin_explore_skills_index"
        />
      </Grid>
    </Grid>
  );
};

export default EmptySkillsCardBody;
